import React from "react";
import Menu from "components/TopNav/Menu";
import Balance from "./Balance";
import Wallet from "./Wallet";
import Message from "./message/Message";
import Profile from "./Profile";
import PageTitle from "./PageTitle";
import SmartPhone from "./SmartPhone";
import Language from "./Language";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
  BELOW_THE_HEADER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER,
} from "constants/ActionTypes";
import classes from "./Header.module.scss";
import { useTranslation } from "react-i18next";

const Container = ({ navigationStyle, horizontalNavPosition }) => {
  const { i18n } = useTranslation();
  return (
    <>
      <span className={classes.MoreVertIcon}></span>
      <AppBar
        style={{
          background: "transparent",
          boxShadow: "none",
        }}
        className={`${
          i18n.dir() === "rtl" ? "app-main-header" : "app-main-header-ltr"
        } ${
          navigationStyle === HORIZONTAL_NAVIGATION &&
          horizontalNavPosition === BELOW_THE_HEADER
            ? "app-main-header-top"
            : ""
        }`}
      >
        <Toolbar
          className="app-toolbar"
          disableGutters={false}
          style={{
            paddingRight: i18n.dir() === "rtl" ? "0px" : "24px",
            paddingLeft: i18n.dir() === "rtl" ? "24px" : "0px",
            direction: i18n.dir() === "rtl" ? "ltr" : "rtl",
          }}
        >
          <Profile />
          <Balance />
          <Language />
          <Wallet />
          <Message />
          {navigationStyle === HORIZONTAL_NAVIGATION &&
            horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}
          <PageTitle />
          <div className="ellipse-shape" />
          <SmartPhone />
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Container;
